export default "__VITE_ASSET___ZWqj8qt__"